import React, { Fragment, useState } from "react";
import { Helmet } from "react-helmet";
import CommonFrom from "../../../Common/Components/Form";
import { FormSubmit } from "./Components/Services";
function Create() {
  const initialState = {
    loading: false,
  };
  const [state, setstate] = useState(initialState);

  const Handler = data => {
    setstate({ loading: true });
    FormSubmit(data).then(() => {
      setstate({
        loading: false,
      });
    });
  };

  return (
    <Fragment>
      <Helmet>
        <title>نیکوتن | ثبت ادمین</title>
      </Helmet>

      <CommonFrom
        form={input}
        loading={state.loading}
        header="ثبت ادمین سایت"
        textbtn="لیست ادمین ها"
        linkbtn="/Admin/User/List"
        btnName="ثبت اطلاعات ادمین"
        submit={Handler}
      />
    </Fragment>
  );
}

export const input = [
  {
    label: "نام",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "fullname",
    value: "",
    type: "text",
  },
  {
    label: "ایمیل",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "email",
    value: "",
    type: "email",
  },
  {
    label: "نام کاربری",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "username",
    value: "",
    type: "text",
  },
  {
    label: "رمز",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "password",
    value: "",
    type: "password",
  },

  {
    label: "نوع مدیر",
    size: "col-md-6",
    classNames: "mt-2",
    placeholder: "",
    name: "role",
    input: "select",
    options: [
      { id: "supporter", name: "پشتیبان" },
      { id: "financial", name: "امور مالی" },
      { id: "contentmaker", name: "تولید محتوا" },
    ],
  },
  {
    label: "عکس پروفایل",
    size: "col-md-12",
    classNames: "mt-2",
    placeholder: "",
    name: "profile",
    input: "file",
    accept: "image/png, image/jpeg",
  },
];

export default Create;
